module.exports = __webpack_public_path__ + "static/media/18ECA27.73c62d93.jpg";